import { DataHeader, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMarketArea extends Layout {
    dataheaderMarketArea: DataHeader;
    panelMarketArea: Panel;
    sourceMarketArea: DataSource;
    textboxDescription: Textbox;
    textboxId: Textbox;
}
